import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _Promise from 'babel-runtime/core-js/promise';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _get from 'lodash/get';
import { mapState, mapMutations } from 'vuex';
import { isFrameSequence, isDragonBones } from '@/views/creative/utils';
import ResUploader from '@/views/repository/components/resUploader.vue';
import BatchUploader from '@/views/repository/components/batch-uploader.vue';
import CropperDialog from '@pt/components/cropper-dialog/index.vue';
import categoryMixin from '@/views/creative/mixin/category.js';
import { readFileAsDataURL } from '@/utils/fileReader.js';
import { validateFrameSequence, validateDragonBones } from '@/views/creative/utils/resource-validator.js';
import resourceMixin from '@/views/creative/mixin/resource.js';
import generateId from '@/utils/generateId.js';
import { uploadFile } from '@/api/common/upload';

export default {
  mixins: [categoryMixin, resourceMixin],

  components: {
    // ResUploader,
    CropperDialog: CropperDialog
  },

  data: function data() {
    return {
      cropperDialogVisible: false,
      cropper: {}
    };
  },


  computed: _extends({}, mapState({
    category: function category(state) {
      return state.creative.template.currentCategory;
    },
    currentResource: function currentResource(state) {
      return state.creative.template.currentResource;
    },
    addRepositoryResourceDialog: function addRepositoryResourceDialog(state) {
      return state.creative.template.addRepositoryResourceDialog;
    },
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig;
    },
    editResourceDialog: function editResourceDialog(state) {
      return state.creative.template.editResourceDialog;
    }
  }), {
    resourceType: function resourceType() {
      return this.category && this.category.res_type;
    },
    uploadComponentType: function uploadComponentType() {
      var batchResources = [6, 7, 8, 9, 10, 14, 15];
      // const batchResources = []
      if (batchResources.includes(this.resourceType) && !this.isEdit) {
        return BatchUploader;
      }
      return ResUploader;
    },
    optionsFilter: function optionsFilter() {
      var filter = {};

      if (this.category && this.category.res_cat1_id) {
        filter.cat1_id = String(this.category.res_cat1_id);
      }
      if (this.category && this.category.res_cat2_id) {
        filter.cat2_id = String(this.category.res_cat2_id);
      }

      return filter;
    },
    isUpdateResource: function isUpdateResource() {
      return this.addRepositoryResourceDialog.action === 'update';
    }
  }),

  watch: {
    'addRepositoryResourceDialog.visible': function addRepositoryResourceDialogVisible(val) {
      var _this = this;

      if (val === true) {
        this.$nextTick(function () {
          _this.$refs.uploader && _this.$refs.uploader.show();
        });
      }
    }
  },

  methods: _extends({
    uploadFile: uploadFile

  }, mapMutations({
    closeEditResourceDialog: 'creative/template/closeEditResourceDialog'
  }), {
    handleClick: function handleClick(e) {
      // 点击资源选择弹窗时，如果 editResourceDialog 展示，则阻止事件冒泡，避免事件传递到 document，然后关闭掉 editResourceDialog
      if (this.editResourceDialog.visible === true) e.stopPropagation();
    },
    handleSubmit: function handleSubmit(val) {
      var _this2 = this;

      console.log(val);
      if (this.$refs.uploader && this.$refs.uploader.isBatch) {
        var params = val.params,
            fileList = val.fileList;

        params.forEach(function (item, index) {
          item.file = fileList[index].file;
          if (_this2.isUpdateResource) _this2.updateResource(item);else _this2.addResource(item);
        });
      } else {
        if (this.isUpdateResource) this.updateResource(val);else this.addResource(val);
      }

      this.close();
    },
    cookResource: function cookResource(val) {
      var resource = {
        file_name: val.file.origin_name,
        res_name: val.name,
        prefix: this.category.prefix,
        resource_type: this.category.resource_type,
        file_path: val.file.file_path,
        file_md5: val.file.md5,
        file_url: val.file.url,
        resource_origin: 'local',
        isRepository: this.category.isRepository,
        category_id: this.category.id,
        // 如果是更新资源则使用资源 id
        id: this.isUpdateResource ? this.currentResource.id : 'fe_id:' + generateId()
      };

      if (this.dataIsZip(val) && (isDragonBones(this.category.prefix) || isFrameSequence(this.category.prefix, this.category.resource_type)) && Array.isArray(_get(val, 'file.files'))) {
        var file = val.file;
        resource.preview_urls = file.files.map(function (item) {
          return file.url + '/' + item;
        });
      }

      if (val.cat1_id) {
        resource.res_cat1_id = val.cat1_id;
      }

      if (val.cat2_id) {
        resource.res_cat2_id = val.cat2_id;
      }

      if (val.tag_ids) {
        resource.res_tag_ids = Array.isArray(val.tag_ids) ? val.tag_ids.join(',') : val.tag_ids;
      }

      return resource;
    },
    addResource: function addResource(val) {
      var resource = _extends({}, this.cookResource(val), {
        is_default: 0
      });
      this.$store.dispatch('creative/template/addResource', resource);
    },
    updateResource: function updateResource(val) {
      var resource = _extends({}, this.cookResource(val));
      this.$store.dispatch('creative/template/updateResource', resource);
    },
    uploadApiData: function uploadApiData(val) {
      if (this.dataIsZip(val)) {
        return { unzip: 1 };
      }
      return {};
    },
    close: function close() {
      this.$store.commit('creative/template/closeAddRepositoryResourceDialog');
      this.$store.commit('creative/template/updateCurrentCategory', null);
      this.$store.commit('creative/template/updateCurrentResource', null);
      this.$refs.uploader.close();
      this.closeEditResourceDialog();
    },
    dataIsZip: function dataIsZip(val) {
      return this.category.file_ext === 'zip' &&
      // 选择序列帧和龙骨时，才认为上传的是 zip 包
      [1, 2].some(function (item) {
        return item === val.cat1_id;
      });
    },
    beforeUpload: function beforeUpload(file) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result, dataURL, fileTypeParts;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this3.isImage) {
                  _context.next = 17;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return readFileAsDataURL(file);

              case 4:
                result = _context.sent;
                dataURL = result.target.result;
                fileTypeParts = file.type.split('/');

                _this3.cropper = {
                  img: dataURL,
                  outputType: fileTypeParts[fileTypeParts.length - 1]
                };
                if (_this3.resourceMetaData) {
                  _this3.cropper = _extends({}, _this3.cropper, {
                    autoCropWidth: _this3.resourceMetaData.width,
                    autoCropHeight: _this3.resourceMetaData.height
                  });
                }
                _this3.cropperDialogVisible = true;
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](1);

                console.error(_context.t0);
                _this3.$message.error('读取图片失败');

              case 16:
                return _context.abrupt('return', _Promise.reject());

              case 17:
                return _context.abrupt('return', true);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[1, 12]]);
      }))();
    },
    resourceValidator: function resourceValidator(_ref) {
      var newFiles = _ref.newFiles,
          oldFiles = _ref.oldFiles;

      var files = newFiles;

      if (this.isFrameSequence) {
        var _validateFrameSequenc = validateFrameSequence({ files: files, oldFiles: oldFiles }),
            _validateFrameSequenc2 = _slicedToArray(_validateFrameSequenc, 2),
            valid = _validateFrameSequenc2[0],
            errors = _validateFrameSequenc2[1];

        if (!valid) this.$message.error(errors[0].message);
        return valid;
      }

      if (this.isDragonBones) {
        var _validateDragonBones = validateDragonBones({
          files: files,
          oldFiles: oldFiles,
          type: this.category.lg_type
        }),
            _validateDragonBones2 = _slicedToArray(_validateDragonBones, 2),
            _valid = _validateDragonBones2[0],
            _errors = _validateDragonBones2[1];

        if (!_valid) this.$message.error(_errors[0].message);
        return _valid;
      }

      return true;
    },
    uploadSuccess: function uploadSuccess(res, file, fileList) {
      if (res.code === 0) {
        var valid = this.resourceValidator({
          newFiles: _get(file, 'response.data.files') || [],
          oldFiles: this.basicResource.preview_urls_for_live_preview
        });
        if (valid) {
          this.setUploadFileList(res.data);
        } else {
          this.clearUploadFileList();
        }
      } else {
        this.clearUploadFileList();
      }
    },
    handleUploadSuccess: function handleUploadSuccess(_ref2) {
      var file = _ref2.file;

      this.setUploadFileList(file);
    },
    setUploadFileList: function setUploadFileList(data) {
      this.$refs.uploader && this.$refs.uploader.setUploadFileList(data);
    },
    clearUploadFileList: function clearUploadFileList() {
      this.$refs.uploader && this.$refs.uploader.clearUploadFileList();
    }
  })
};